import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PaymentIntent, PaymentsState } from './paymentsTypes';

const initialState: PaymentsState = {
  currentIntent: null,
  paymentHistory: [],
  loading: false,
  error: null,
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setCurrentIntent: (state, action: PayloadAction<PaymentIntent | null>) => {
      state.currentIntent = action.payload;
    },
    
    addToHistory: (state, action: PayloadAction<PaymentIntent>) => {
      state.paymentHistory.unshift(action.payload);
    },
    
    clearHistory: (state) => {
      state.paymentHistory = [];
    },
    
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setCurrentIntent,
  addToHistory,
  clearHistory,
  setLoading,
  setError,
} = paymentsSlice.actions;

export default paymentsSlice.reducer;
